import {NgModule} from "@angular/core";
import {LogsComponent} from "./logs.component";
import {MatCardModule} from "@angular/material/card";
import {MatListModule} from "@angular/material/list";
import {MatButtonToggleModule} from "@angular/material/button-toggle";
import {MatButtonModule} from "@angular/material/button";
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatIconModule} from "@angular/material/icon";
import {MatTableModule} from "@angular/material/table";
import {MatPaginatorModule} from "@angular/material/paginator";
import {MatSortModule} from "@angular/material/sort";
import {DisplayDateModule} from "@app/pipes/display-date/display-date.module";
import {LogPipeModule} from "@app/pipes/log/log-pipe.module";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {FormatDatePipeModule} from "@app/pipes/format-date/format-date-pipe.module";
import {FormatDatePipe} from "@app/pipes/format-date/format-date.pipe";
import {MatInputModule} from "@angular/material/input";
import {MatSelectModule} from "@angular/material/select";
import {OrderByModule} from "@app/pipes/order-by/order-by.module";
import {UsernameToNameModule} from "@app/pipes/username-to-name/username-to-name.module";

@NgModule({
    declarations:[LogsComponent],
    imports: [
        MatCardModule,
        MatListModule,
        MatButtonToggleModule,
        MatButtonModule,
        CommonModule,
        FormsModule,
        MatFormFieldModule,
        MatIconModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        DisplayDateModule,
        LogPipeModule,
        MatDatepickerModule,
        FormatDatePipeModule,
        MatInputModule,
        MatSelectModule,
        OrderByModule,
        UsernameToNameModule
    ],
    providers: [FormatDatePipe]
})
export class LogsModule { }
